import { userApi } from './userApi'

export const userClient = {
  getProfile: () => userApi.get('/auth/me'),

  getRecommended: (params?: {
    limit?: number
    offset?: number
    contentType?: 'all' | 'trip' | 'event' | 'post'
  }) => userApi.get('/recommended', { params }),

  getPosts: (params?: {
    user_id?: string
    trip_id?: string
    event_id?: string
    content_type?: 'text' | 'photo' | 'gallery' | 'trip' | 'event'
    limit?: number
    offset?: number
  }) => userApi.get('/posts', { params }),

  createPost: (payload: {
    content_type: 'text' | 'photo' | 'gallery' | 'trip' | 'event'
    description?: string | null
    privacy?: 'public' | 'friends' | 'private'
    trip_id?: string | null
    event_id?: string | null
    location_id?: string | null
    media?: Array<{
      file_id: string
      caption?: string | null
      order_index?: number
    }>
  }) => userApi.post('/posts', payload),

  getTrips: async (params?: {
    status?: 'planning' | 'active' | 'completed' | 'archived'
    created_by?: string
    limit?: number
    offset?: number
  }) => {
    try {
      return await userApi.get('/trips', { params })
    } catch (error: any) {
      if (params?.created_by && error?.response?.status === 500) {
        const fallbackParams = { ...params }
        delete (fallbackParams as any).created_by
        return userApi.get('/trips', { params: fallbackParams })
      }
      throw error
    }
  },

  getTrip: (id: string) => userApi.get(`/trips/${id}`),
  getTripFull: (id: string) => userApi.get(`/trips/${id}/full`),

  createTrip: (payload: {
    title: string
    description?: string | null
    status?: 'planning' | 'active' | 'completed' | 'archived'
    privacy?: 'public' | 'unlisted' | 'private'
    type?: 'live' | 'shared' | 'personal'
    start_date?: string | null
    end_date?: string | null
  }) => userApi.post('/trips', payload),

  updateTrip: (
    id: string,
    payload: Partial<{
      title: string
      description: string | null
      status: 'planning' | 'active' | 'completed' | 'archived'
      privacy: 'public' | 'unlisted' | 'private'
      type: 'live' | 'shared' | 'personal'
      start_date: string | null
      end_date: string | null
      cover_image_url: string | null
    }>
  ) => userApi.patch(`/trips/${id}`, payload),

  deleteTrip: (id: string) => userApi.delete(`/trips/${id}`),

  getTripEvents: (tripId: string) => userApi.get(`/events/trip/${tripId}`),
  createTripEvent: (payload: {
    trip_id: string
    title: string
    description?: string | null
    start_date: string
    end_date?: string | null
  }) => userApi.post('/events', payload),
  updateTripEvent: (eventId: string, payload: Record<string, unknown>) =>
    userApi.patch(`/events/${eventId}`, payload),
  deleteTripEvent: (eventId: string) => userApi.delete(`/events/${eventId}`),

  getTripFiles: (params: { trip_id: string; limit?: number; offset?: number }) =>
    userApi.get('/files', { params }),

  getTripNotes: (params: { trip_id: string }) => userApi.get('/notes', { params }),
  createTripNote: (payload: { trip_id: string; title: string; body?: string | null }) =>
    userApi.post('/notes', payload),
  updateTripNote: (noteId: string, payload: Record<string, unknown>) =>
    userApi.patch(`/notes/${noteId}`, payload),
  deleteTripNote: (noteId: string) => userApi.delete(`/notes/${noteId}`),

  getTripParticipants: (tripId: string) =>
    userApi.get(`/trips/${tripId}/participants`),
  respondTripParticipant: (tripId: string, payload: { status: 'accepted' | 'declined' }) =>
    userApi.post(`/trips/${tripId}/participants/respond`, payload),

  getEvents: (params?: { limit?: number; offset?: number }) =>
    userApi.get('/events/public', { params }),

  getExplore: async (params?: Record<string, unknown>) => {
    try {
      return await userApi.get('/trips/following', { params })
    } catch (error: any) {
      if (error?.response?.status === 500) {
        return userApi.get('/trips/recommended', { params })
      }
      throw error
    }
  },
}
